import { render, staticRenderFns } from "./DashboardEdit.vue?vue&type=template&id=b6798d58&scoped=true&"
import script from "./DashboardEdit.vue?vue&type=script&lang=js&"
export * from "./DashboardEdit.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEdit.vue?vue&type=style&index=0&id=b6798d58&prod&lang=scss&"
import style1 from "./DashboardEdit.vue?vue&type=style&index=1&id=b6798d58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6798d58",
  null
  
)

export default component.exports